import settings from '../config/settings';
import axios from './axios';

const { apiBaseURL } = settings;

export default class SectionApi {
  static getSection(id) {
    return axios.get(`${apiBaseURL}/sections/${id}`);
  }

  static getSections() {
    return axios.get(`${apiBaseURL}/sections`);
  }
}



// WEBPACK FOOTER //
// ./src/api/SectionApi.js